var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-6 has-text-centered"},[_vm._m(0),_vm._t("default")],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"mb-4"},[_c('span',{staticClass:"icon has-text-success"},[_c('i',{staticClass:"mdi mdi-check-circle-outline mdi-48px"})])])
}]

export { render, staticRenderFns }